import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=93d8cd38&scoped=true&"
import script from "./table-header.js?vue&type=script&lang=js&"
export * from "./table-header.js?vue&type=script&lang=js&"
import style0 from "../table.scss?vue&type=style&index=0&id=93d8cd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d8cd38",
  null
  
)

export default component.exports